import ApiService from "../../commons/services/ApiService";
import CompanyAPI from '../company/CompanyAPI';

const apiService = new ApiService();

const companyAPI = new CompanyAPI();

export default class WhatsappAPI {

    URI_V1 = "/v1/whatsapp"

    getQrCodeToConnect = async () => {
        return await apiService.get(`${this.URI_V1}/qrcode-connect?companyId=${companyAPI.getCompanyManagment().id}`);
    };

    logout = async () => {
        return await apiService.put(`${this.URI_V1}/logout?companyId=${companyAPI.getCompanyManagment().id}`, null);
    };

    getStatus = async () => {
        return await apiService.get(`${this.URI_V1}/status?companyId=${companyAPI.getCompanyManagment().id}`);
    };


    saveBotConfig = async (data: any) => {
        return await apiService.put(`${this.URI_V1}/company-config?companyId=${companyAPI.getCompanyManagment().id}`, data);
    };


    getBotConfig = async () => {
        return await apiService.get(`${this.URI_V1}/company-config?companyId=${companyAPI.getCompanyManagment().id}`);
    };

    

}
